import ScrollToTopOnMount from '../../components/ScrollToTopOnMount/ScrollToTopOnMount';
const SetUpMetaMaskWallet = () => {
    return(
        <div className="max-w-[1500px] mx-auto px-[5vw] lg:px-20 mb-20 md:mb-36">
            <ScrollToTopOnMount />
            <div className="max-w-[1000px] mx-auto">

                <h1 className='mb-5 secondary_heading leading-60px md:leading-60px 2xl:leading-84px text-lg sm:text-50px md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-bold '>
                    How to Easily Setup a MetaMask Wallet
                </h1>
                <div className="flex flex-wrap mb-5">
                    <p className="m-3 text-sm sm:text-base text-gray-400 tracking-wider">
                        May 20, 2022
                    </p>
                    <p className="m-3 text-sm sm:text-base text-gray-400 tracking-wider">
                        <span className="text-gray-300">By </span> May 20, 2022
                    </p>
                    <p className="m-3 text-sm sm:text-base text-gray-400 tracking-wider">
                        Learn
                    </p>
                </div>

                <div className="w-full max-w-[600px] mx-auto mb-8">
                    <img src = 'https://images.unsplash.com/photo-1601592996763-f05c9c80a7f1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80' 
                        alt="wallet" className="w-full rounded-t-[8px]"/>
                </div>

                <p className="mb-8 text-sm sm:text-base text-gray-300 tracking-wider">
                    Looking to kick off your NFT collection, but not sure where to begin? The first thing you’ll need is a crypto wallet, which will store your method of payment and allow you to access your new NFT. A crypto wallet allows you to purchase, send and receive your NFTs, as well as interact with blockchain-integrated websites—commonly known as decentralized applications (or dapps, for short)—like OpenSea.
                </p>
                <p className="mb-8 text-sm sm:text-base text-gray-300 tracking-wider">
                    In this post, we’ll walk through how to quickly get started with MetaMask, a popular crypto wallet.
                </p>

                <h1 className='mb-5 secondary_heading leading-60px md:leading-60px 2xl:leading-84px text-lg sm:text-50px md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-bold '>
                    Getting Started with MetaMask
                </h1>

                <div className="pl-5 sm:pl-10 mb-16 sm:mb-20">
                    <ul className="list-decimal">
                        
                        <li className="mb-10">
                            <p className="text-sm mb-5 sm:text-base text-gray-300 tracking-wider">
                                Visit <a href='https://metamask.io/download/' target='_blank' rel = 'noreferrer'>https://metamask.io/download/</a>.
                            </p>
                            <div className='w-full max-w-[700px] mx-auto'>
                                <img src = {require('../../assets/images/learn/setupmeta1.png')} alt = 'learn' className="w-full rounded-[8px]" />
                            </div>
                        </li>
                        <li className="mb-5">
                            <p className="text-sm sm:text-base text-gray-300 tracking-wider">
                                Choose your application and click the <span className = 'font-[600] text-white'> Install MetaMask </span> button. 
                            </p>
                            
                        </li>
                        <li className="mb-10">
                            <p className="text-sm mb-5 sm:text-base text-gray-300 tracking-wider">
                                Choose “Create New Account” and follow the instructions to set up your password. 
                            </p>
                            <div className='w-full max-w-[700px] mx-auto'>
                                <img src = {require('../../assets/images/learn/setupmeta2.gif')} alt = 'learn' className="w-full rounded-[8px]" />
                            </div>
                        </li>
                        <li className="mb-10">
                            <p className="text-sm mb-5 sm:text-base text-gray-300 tracking-wider">
                                Next, make sure to back up your 12-word Secret Recovery Phrase (also known as a Seed Phrase). You should keep this safe (don’t store it digitally) and never reveal it to anyone. For more security tips, please read our wallet security guide. 
                            </p>
                            <div className='w-full max-w-[700px] mx-auto'>
                                <img src = {require('../../assets/images/learn/setupmeta3.gif')} alt = 'learn' className="w-full rounded-[8px]" />
                            </div>
                        </li>
                        <li className="mb-10">
                            <p className="text-sm mb-5 sm:text-base text-gray-300 tracking-wider">
                            Now you’re ready to connect your wallet! Visit OpenSea.io, click the wallet icon in the top right corner and select MetaMask.
                            </p>
                            <div className='w-full max-w-[700px] mx-auto'>
                                <img src = {require('../../assets/images/learn/setupmeta4.gif')} alt = 'learn' className="w-full rounded-[8px]" />
                            </div>
                        </li>

                    </ul>
                </div>

            </div>

        </div>
    )
}

export default SetUpMetaMaskWallet;